<template>
</template>
       
<script>
  export default {
    name: 'reload',
            
    mounted () {
        this.$router.push({ name: 'realizarPedido' });
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/realizarPedido/reload.vue